import React from "react";
import {Building2} from "lucide-react";

const MFFloatingNav = ({
  active = "overview"
}) => {

  const items = [

    {
      key: "overview",
      label: "Overview",
      href: "/mf/",
      icon: "dashboard",
    },

    {
      key: "explorer",
      label: "Explorer",
      href: "/mfe/",
      icon: "search",
    },

    // {
    //   key: "sip",
    //   label: "SIP",
    //   href: "/mfsip/",
    //   icon: "savings",
    // },
    {
      label: "AMC Partners",
      icon: "dashboard",
      href: "/mfpartners/",
      key: "partners"
    }

  ];

  return (

      <div
        className="
          fixed
          top-[150px]
          left-1/2
          -translate-x-1/2
          z-40
          hidden
          lg:flex
        "
      >

      <div
        className="
          flex
          items-center
          gap-2

          bg-white/15
          backdrop-blur-xl

          border
          border-white/40

          shadow-[0_8px_32px_rgba(0,0,0,0.10)]

          rounded-2xl

          px-3
          py-3
        "
      >

        {items.map((item) => (

          <a
            key={item.key}
            href={item.href}
            className={`
              flex
              items-center
              gap-2

              px-4
              py-3

              rounded-xl

              text-sm
              font-semibold

              transition-all
              duration-200

              ${
                active === item.key
                  ? `
                    bg-green-700
                    text-white
                    shadow-md
                  `
                  : `
                    text-gray-700
                    hover:bg-green-50
                    hover:text-green-700
                  `
              }
            `}
          >

            <span
              className="
                material-symbols-outlined
                text-[18px]
              "
            >
              {item.icon}
            </span>

            {item.label}

          </a>

        ))}

      </div>

    </div>

  );
};

export default MFFloatingNav;